<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_step3_rates.svg`)"
            imageLabel="Rates & Fees"
            heading="Do you want to include additional fees?"
            :step="9"
        >

            <div class="ph3 ph4-ns">
                <!-- boolean buttons -->
                <Toggle @change="toggle($event)" class="pb4"/>

                <!-- conditional if click on yes -->
                <AddFees 
                    v-for="(fee, index) in additionalFees" 
                    :key="index"
                    :fee="fee"
                    @delete="deleteFee(index)"
                />

                <!-- add custom fee -->
                <div v-if="showMore" class="pb4">
                    <div @click="addFee" class="flex pointer">
                        <img src="@/assets/img/icon_listmytools_add.svg"/>
                        <h6 class="ml2 yellow">Add Fee</h6>
                    </div>
                </div>

            </div>
        
        </ListContainer>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" forward="Post Listing" @backClick="$router.push('/deposit')" @forwardClick="next"/>
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import Toggle from '@/components/controls/Toggle.vue';
import AddFees from '@/components/list/additionalFees/AddFees.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { mapActions, mapMutations } from 'vuex';

export default {
    components: {
        ShadowBoxContainer,
        ListContainer,
        Toggle,
        AddFees,
        NavigationButtons
    },
    data() {
        return {
            showMore: null,
            additionalFees: []
        };
    },
    methods: {
        ...mapMutations('newListing', ['setFees']),
        ...mapActions('newListing', ['postListing']),
        toggle(event) {
            if (event.value === true) {
                if (this.showMore === false || this.showMore === null) {
                    this.addFee();
                    this.showMore = true;
                }
            } else {
                this.showMore = false;
                this.additionalFees = [];
            }
        },
        addFee() {
            this.additionalFees.push({
                name: '',
                amount: 0,
                description: ''
            });
        },
        deleteFee(index) {
            this.$delete(this.additionalFees, index);
        },
        next() {
            this.setFees(this.additionalFees);
            this.postListing().then(object => {
                this.$router.push({
                    path: '/listing-detail/' + object.data.data.id
                });
            });
        }
    }
};
</script>
